import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { CityProfile, InterestedUser } from 'app/shared/objects/cities';
import { AuthService } from 'app/auth/auth.service';

@Injectable()
export class PublicCityProfileService {

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {
  }

  getCityProfile(id: string): Promise<CityProfile> {
    return this.http.get(environment.apiURL + '/frontEndOpen/cityProfile/' + id)
      .toPromise()
      .then(response => {
        return response as CityProfile;
      })
      .catch(error => {
        return null;
      });
  }

  interestedUser(user: InterestedUser) {
    return this.http.post(environment.loginApiURL + '/interestedUser', user)
      .toPromise()
      .then(response => response as InterestedUser)
      .catch(error => {
        console.log('error verifying user: ' + JSON.stringify(error));
        return null;
      });
  }

}


